export const Messages = {
  PleaseEnter: "を入力してください。",
  Must: "（必須）",
  DeleteConfirmation: "削除確認",
  DeleteAreYourSureYouWantTo: "削除してもよろしいですか？",
  CommonErrorMsg: "システムエラーが発生しました。",
  ErrorOccurred: "に失敗しました",
  DownloadFailed: "ダウンロードに失敗しました。",
} as const;
